export const baseConfirmModalName = 'base-confirm';
